<template>
  <div class="inline-flex">
      <button v-show="isHidden" v-on:click="isHidden = !isHidden" class="bg-transparent inline-block p-0 text-indigo-500"><i aria-hidden="true" class="material-icons align-middle text-3xl">add_box</i></button>
    <div v-if="!isHidden" class="dropdown flex w-full max-w-lg transition items-center flex-wrap">
          <div class="flex-1 pr-1 w-10/12">
            <v-select
              :options="options"
              label="name"
              v-model="selected"
              :placeholder="placeholder"
              class="text-xs leading-normal border"
              >
              <template v-slot:option="option">
                  <div class="flex flex-wrap py-2 -my-1 border-b border-gray-300">
                      <strong class="w-full md:w-3/4 py-0 truncate">{{ option.name }}</strong>
                      <div class="w-full md:w-1/4 text-xxs py-0 text-gray-750 truncate">{{ option.report_type }}</div>
                      <div class="w-full text-xxs py-0 text-orange-700">{{ option.internal_notes }}</div>
                    </div>
                </template>
              </v-select>
          </div>
          <div class="w-2/12">
              <button v-if="selected" v-on:click="postItem" type="submit" class="commitbutton p-0 inline-block"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
          </div>
        <div class="w-full text-xs bg-orange-400 mt-2 py-1 px-2 rounded"><strong>Warning:</strong> {{ alert }}</div>
      </div>
 
  </div>
</template>

<script>
    import VueSelect from 'vue-select';
    import axios from 'axios'

    export default {

        components: { VueSelect },

        props: {
            options: '',
            placeholder: {
                default: 'Add Item' 
            },
            route: '',
            idname: '',
            alert: {
              default: 'Any report added here is immediately assigned.',
            },
        },

        data() {
          return {
            isHidden: true,
            success: false,
            loaded: true,
            groupId: '',
            name: '',
            selected: '',
          }
        },

        methods: {

          postItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.post(
                  this.route.replace("selected.id", this.selected.id)
                ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },

    }
</script>
